import { gql } from '../../../generated';

const StatusChart = gql(/* GraphQL */ `
  query StatusChart(
    $currency_id: String!
    $gate_group_id: String
    $operation_type: StatusChartOperationType!
    $period: DashboardV2PeriodType!
  ) {
    dashboardWidgetsStatusChartV2(
      currency_id: $currency_id
      gate_group_id: $gate_group_id
      operation_type: $operation_type
      period: $period
    ) {
      data {
        status
        percent
        count
      }
    }
  }
`);

export default StatusChart;
